<template>
  <div>
    <div class="monitor container is-fluid">
      <div class="columns">
        <page-header title="Tipos de Entrega"></page-header>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-table
            :narrowed="true"
            :bordered="true"
            :data="tiposEntrega"
            :paginated="true"
            :per-page="tamanoPagina"
            :current-page.sync="paginaActual"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort="user.id"
            aria-next-label="Siguiente página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
          >
            <b-table-column
              v-slot="props"
              field="nombre"
              label="Nombre Tipo Entrega"
            >
              <span> {{ props.row.nombre }} </span>
            </b-table-column>
            <b-table-column
              field="tipoAsignacion"
              label="Tipo Asignación"
              width="12%"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Corresponde al tipo de asignación para tipo de entrega. Puede ser Rotativa, Heredada o Manual."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <span>
                  {{ props.row.tipoAsignacion }}
                </span>
              </template>
            </b-table-column>
            <b-table-column
              field="usaSemaforo"
              label="Tiempo transcurrido usa color?"
              width="13%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si el tipo de entrega muestra en color el tiempo restante (No implementado)."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="definirIcono(props.row.usaSemaforo)" />
              </template>
            </b-table-column>
            <b-table-column
              field="mostrarSinFacturar"
              label="Muestra pedido sin anticipo?"
              width="13%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si el tipo de entrega permite mostrar pedidos sin validar si fue pagado."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="definirIcono(props.row.mostrarSinFacturar)" />
              </template>
            </b-table-column>
            <b-table-column
              field="puedePausar"
              label="Puede pausar pedidos?"
              width="13%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si el tipo de entrega permite pausar/reanudar pedidos."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="definirIcono(props.row.puedePausar)" />
              </template>
            </b-table-column>
            <b-table-column
              field="tieneEntregaPosterior"
              label="Tiene entrega posterior?"
              width="13%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si el tipo de entrega permite agendar pedidos con posterioridad."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="definirIcono(props.row.tieneEntregaPosterior)" />
              </template>
            </b-table-column>
            <b-table-column
              v-slot="props"
              label="Acciones"
              width="8%"
              :centered="true"
            >
              <div class="buttons">
                <b-button
                  type="is-info"
                  size="is-small"
                  title="Modificar"
                  @click="modificarRegistro(props.row.id)"
                >
                  <b-icon icon="pencil-alt" />
                </b-button>
                <b-button
                  v-if="props.row.tieneEntregaPosterior"
                  type="is-success"
                  size="is-small"
                  title="Tiempos asignación"
                  @click="modificarTiemposAsignacion(props.row.id)"
                >
                  <b-icon icon="stopwatch" />
                </b-button>
              </div>
            </b-table-column>
            <template slot="empty">
              <div class="content has-text-grey has-text-centered">
                <p>No hay registros.</p>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="estaModalAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarModalHandle"
    >
      <tipo-entrega-form
        :modificacion="modificacion"
        :objeto="objeto"
        :bodega="bodega.id"
        :titulo="tituloForm"
        :es-monitor="esMonitor || esJefeBodega"
        @close="cerrarModalHandle"
      />
    </b-modal>
    <b-modal
      :active.sync="estaModalTiemposAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarModalTiemposHandle"
    >
      <tiempos-asignacion-form
        :bodega="bodega"
        :objeto="objeto"
        :titulo="tituloForm"
        :es-monitor="esMonitor"
        @close="cerrarModalTiemposHandle"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import TiemposAsignacionForm from '@/components/mantenedor/tiposEntrega/TiemposAsignacionForm.vue'
import TipoEntregaForm from '@/components/mantenedor/tiposEntrega/TipoEntregaForm.vue'
import PageHeader from '@/components/shared/PageHeader.vue'
import disponibilidadMixin from '@/mixins/disponibilidad.js'
import { tipoEntregaBodegaService } from '@/services'

export default {
  name: 'TiposEntrega',
  components: {
    TipoEntregaForm,
    TiemposAsignacionForm,
    PageHeader
  },
  mixins: [disponibilidadMixin],
  data() {
    return {
      tiposEntrega: [],
      estaModalAbierto: false,
      estaModalTiemposAbierto: false,
      paginaActual: 1,
      tamanoPagina: 10,
      tituloForm: null,
      objeto: null,
      modificacion: false
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    puedeAgregar() {
      return this.bodega
    },
    esMonitor() {
      return this.bodega.roles.some((item) => item.id === 6)
    },
    esJefeBodega() {
      return this.bodega.roles.some((item) => item.id === 7)
    }
  },
  created() {
    this.getTiposEntrega()
  },
  methods: {
    modificarRegistro(id) {
      this.tituloForm = 'Modificar Tipo Entrega'
      this.objeto = this.tiposEntrega.filter((item) => item.id === id)[0]
      this.modificacion = true
      this.estaModalAbierto = true
    },
    modificarTiemposAsignacion(id) {
      this.tituloForm = 'Modificar Tiempos Asignación'
      this.objeto = this.tiposEntrega.filter((item) => item.id === id)[0]
      this.estaModalTiemposAbierto = true
    },
    cerrarModalHandle(payload = false) {
      this.estaModalAbierto = false
      this.tituloForm = ''
      this.objeto = null
      this.modificacion = false
      if (payload) {
        this.getTiposEntrega()
      }
    },
    cerrarModalTiemposHandle(payload) {
      this.estaModalTiemposAbierto = false
      if (payload.update) {
        this.actualizarUbicaciones(payload.zonaId)
      }
    },
    async getTiposEntrega() {
      try {
        const response = await tipoEntregaBodegaService.getTiposEntregaByBodega(
          this.bodega.id
        )
        this.tiposEntrega = response.data
      } catch (error) {
        this.procesarError(error)
      }
    }
  }
}
</script>
